module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexpage"
  }, [_c('headerpage', {
    attrs: {
      "status": 0
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "position": "relative"
    },
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "top": "0"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.common.home_pic)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "box_top_img",
    attrs: {
      "src": require("../../assets/images/qie/10.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box_bot"
  }, [_c('div', {
    staticClass: "box_bot_tt"
  }, [_c('div', {
    staticClass: "box_bot_tt_t",
    class: _vm.topindex == 0 ? 'box_sty' : '',
    on: {
      "click": function($event) {
        _vm.topindex = 0
      }
    }
  }, [_vm._v("查公司")]), _vm._v(" "), _c('div', {
    staticClass: "box_bot_tt_t",
    class: _vm.topindex == 1 ? 'box_sty' : '',
    on: {
      "click": function($event) {
        _vm.topindex = 1
      }
    }
  }, [_vm._v("查政策")])]), _vm._v(" "), _c('div', {
    staticClass: "box_bot_cet"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "box_bot_cet_left",
    attrs: {
      "placeholder": _vm.topindex == 0 ? '请输入公司名称' : '请输入政策名称'
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box_bot_cet_right",
    on: {
      "click": _vm.sou
    }
  }, [_c('i', {
    staticClass: "el-icon-search",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("\n                    搜索\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box1 adaptation"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.cetlist), function(item, index) {
    return _c('div', {
      staticClass: "box1_cent"
    }, [_c('div', {
      staticClass: "box1_cent_top"
    }, [_c('img', {
      staticClass: "box1_cent_top_t",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box1_cent_top_t1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "box1_cent_top_t3",
      on: {
        "click": function($event) {
          return _vm.listchange(item.path, item.listtype)
        }
      }
    }, [_vm._v("更多>>")])]), _vm._v(" "), _vm._l((item.list), function(eitem, eindex) {
      return _c('div', {
        staticClass: "box1_cent_cet",
        on: {
          "click": function($event) {
            return _vm.jumpdetail(eitem.id, item.type)
          }
        }
      }, [_c('div', {
        staticClass: "box1_cent_cet_t"
      }), _vm._v(" "), _c('div', {
        staticClass: "box1_cent_cet_t1"
      }, [_vm._v(_vm._s(eitem.title))]), _vm._v(" "), _c('div', {
        staticClass: "box1_cent_cet_t2"
      }, [_vm._v(_vm._s(eitem.new_time))])])
    }), _vm._v(" "), (item.list.length == 0) ? _c('div', [_c('Nomore')], 1) : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "box1 adaptation",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_vm._m(1), _vm._v(" "), _c('el-carousel', {
    staticClass: "box2",
    attrs: {
      "height": "150px",
      "indicator-position": "outside"
    }
  }, _vm._l((_vm.qylist), function(item) {
    return _c('el-carousel-item', [_c('div', {
      staticClass: "box2_cent"
    }, _vm._l((item), function(eitem) {
      return _c('img', {
        staticClass: "box2_cet",
        attrs: {
          "src": _vm._f("addurl")(eitem.image)
        }
      })
    }), 0)])
  }), 1)], 1), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "box1_cent1",
    attrs: {
      "href": "/information",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "box1_cent1_tt"
  }, [_vm._v("中原国家广告产业园数据大屏")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box1_cent_top"
  }, [_c('img', {
    staticClass: "box1_cent_top_t",
    attrs: {
      "src": require("../../assets/images/qie/3.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box1_cent_top_t1"
  }, [_vm._v("优秀企业")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c1ec454"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = 904
// module chunks = 1